module.exports = __webpack_public_path__ + "media/images/shorts-mail-556c70e17fcf5498d4a91d6d43ea8990.svg";